import React from 'react';
import { motion } from 'framer-motion';
export function BonusesSection() {
  const bonuses = [{
    title: 'Planificador Anti-Caos',
    desc: 'Organizá tu semana en minutos',
    value: '$8.000'
  }, {
    title: 'Guía de Motivación Real',
    desc: 'Cómo sostener sin ganas',
    value: '$10.000'
  }, {
    title: 'Recetario Simple',
    desc: 'Comer bien sin complicarte',
    value: '$9.000'
  }, {
    title: 'Ejercicios Explicados',
    desc: 'Entrená con seguridad',
    value: '$8.000'
  }, {
    title: 'Reto 7 Días',
    desc: 'Volvé a activarte rápido',
    value: '$9.000'
  }, {
    title: 'Manual para Profesoras',
    desc: 'Para entrenadoras o emprendedoras fitness',
    value: '$9.000'
  }];
  return <section className="py-10 px-4 sm:px-6 lg:px-8 bg-pink-50/50 border-y border-pink-200" data-id="element-20">
      <div className="max-w-6xl mx-auto" data-id="element-21">
        <div className="text-center mb-8" data-id="element-22">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-block bg-pink-100 border border-pink-200 text-brand-accent px-6 py-2 rounded-full mb-6" data-id="element-23">
            <span className="font-bold tracking-wide uppercase text-sm" data-id="element-24">
              INCLUIDOS HOY
            </span>
          </motion.div>
          <h2 className="font-display text-3xl md:text-5xl font-bold flex flex-col md:flex-row items-center justify-center gap-3 text-gray-900" data-id="element-25">
            <span data-id="element-26">🎁</span> 6 BONOS ESTRATÉGICOS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8" data-id="element-27">
          {bonuses.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-dark border border-pink-200 rounded-2xl p-6 relative overflow-hidden group shadow-sm" data-id="element-28">
              <div className="absolute top-0 right-0 w-32 h-32 bg-pink-100 rounded-bl-full -mr-16 -mt-16 transition-transform group-hover:scale-110" data-id="element-29" />

              <div className="text-sm font-bold text-brand-accent mb-3 flex items-center gap-2" data-id="element-30">
                <span data-id="element-31">🎁</span> BONO {i + 1}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-32">
                {bono.title}
              </h3>
              <p className="text-gray-500 mb-6" data-id="element-33">{bono.desc}</p>

              <div className="mt-auto pt-4 border-t border-pink-200/50 flex items-center justify-between" data-id="element-34">
                <span className="text-gray-400 line-through text-sm" data-id="element-35">
                  {bono.value}
                </span>
                <span className="text-brand-success font-bold" data-id="element-36">GRATIS</span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-pink-100 via-pink-50 to-transparent border border-pink-200 rounded-2xl p-6 md:p-8 text-center max-w-3xl mx-auto" data-id="element-37">
          <p className="text-xl md:text-2xl font-bold text-gray-900" data-id="element-38">
            <span className="text-2xl mr-2" data-id="element-39">💰</span>
            Valor total bonos:{' '}
            <span className="text-gray-400 line-through mx-2" data-id="element-40">$53.000</span>
            <span className="text-brand-accent ml-2" data-id="element-41">→ GRATIS HOY</span>
          </p>
        </motion.div>
      </div>
    </section>;
}